'use client';
import { createStyles, rem } from '@s7/styles';

var useStyles = createStyles(function(theme, param) {
    var states = param.states, state = param.state;
    var stateParams = states == null ? void 0 : states[state != null ? state : "default"];
    var _stateParams_color;
    var color = (_stateParams_color = stateParams == null ? void 0 : stateParams.color) != null ? _stateParams_color : theme.palette.text.secondary;
    return {
        hint: {
            color: color,
            wordBreak: "break-word",
            display: "block",
            marginLeft: rem(2)
        }
    };
});

export { useStyles as default };
